module.exports = Object.freeze({
    api: "https://altamedicosaz.com.mx:5001/"
    //api: "http://localhost:5011/",
});

